/**
 * Formats a schedule date for display, honouring the reader's locale — `pt` renders
 * `05/10/2023`, `en` renders `10/05/2023`.
 *
 * The date is rebuilt from its parts instead of being handed to `new Date(string)`:
 * an ISO date string parses as UTC midnight, which in any negative-offset timezone
 * (Brazil included) would render the previous day.
 *
 * @param date - The date string to format. Must be in the format YYYY-MM-DD.
 * @param locale - BCP 47 locale tag. Falls back to the runtime's locale when omitted.
 * @returns The formatted date string, or an empty string when there is no date.
 */
export const formatScheduleDate = (date?: string, locale?: string): string => {
  if (!date) return '';

  const [year, month, day] = date.split('-').map(Number);

  if (!year || !month || !day) return '';

  return new Date(year, month - 1, day).toLocaleDateString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
